import { Directive, ElementRef, Input, inject } from '@angular/core';
import { NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';

export enum DropdownMenuType {
  Base = 'ngbDropdownMenuRef',
  Form = 'ngbDropdownMenuFormRef'
}

@Directive({
  selector: '[dropdownRef]'
})
export class DropdownRefDirective {
  el = inject<ElementRef<HTMLElement>>(ElementRef);
  ngbDropdownMenu = inject(NgbDropdownMenu);

  @Input('dropdownRef') id!: DropdownMenuType;
}
